export const withBlockStatus = (blockStates, blockId, status) => ({ ...blockStates, [blockId]: { status } })

export const getImageSize = async file => {
  try {
    const bitmap = await createImageBitmap(file)
    const size = { width: bitmap.width, height: bitmap.height }

    bitmap.close()

    return size
  } catch {
    return null
  }
}
